// components/Loader.tsx
import React from 'react';
import './Loader.css'; // Optional for styling

const Loader: React.FC = () => {
  return (
    <div className="loader-overlay">
      <div className="spinner-border" role="status">
  <span className="sr-only">Loading...</span>
</div>
    </div>
  );
};

export default Loader;